import { AppProvider } from "@providers"
import { config } from "@lib/config"

import { AnalyticsModel } from "./analytics.model"
import { BlogModel } from "./blog.model"
import { FaqModel } from "./faq.model"
import { GlobalModel } from "./global.model"
import { ModalModel } from "./modal.model"
import { ResponsiveModel } from "./responsive.model"
import { SubscriptionModel } from "./subscription.model"
import { AppModels } from "./app.model"
import { PaymentTipsModel } from "./payment-tips.model"
import { InappPurchasesModel } from "./inapp-purchases.model"
import { ContactUsModel } from "./contact-us.model"
import { HuaweiTipsModel } from "./huawei-tips.model"
import { VacanciesModel } from "./vacancies.model"
import { AndroidPaymentsModel } from "./android-payments.model"
import { LegalModel } from "./legal.model"
import { TeamPageModel } from "./team-page.model"
import { GDPRModel } from "./gdpr.model"

export function modelsInit(): AppModels {
  const providers = new AppProvider()
  providers.init()

  const models = new AppModels()
  const analyticsModel = new AnalyticsModel({ Providers: providers })
  const blogModel = new BlogModel({ Providers: providers })
  const faqModel = new FaqModel({ Providers: providers })
  const globalModel = new GlobalModel({ Providers: providers })
  const modalsModel = new ModalModel({ Providers: providers })
  const responsiveModel = new ResponsiveModel({ Providers: providers })
  const subscriptionModel = new SubscriptionModel({ Providers: providers })
  const paymentTipsModel = new PaymentTipsModel({ Providers: providers })
  const inappPurchasesModel = new InappPurchasesModel({ Providers: providers })
  const contactUsModel = new ContactUsModel({ Providers: providers })
  const huaweiTipsModel = new HuaweiTipsModel({ Providers: providers })
  const vacanciesModel = new VacanciesModel({ Providers: providers })
  const androidPaymentsModel = new AndroidPaymentsModel({
    Providers: providers,
  })
  const legalModel = new LegalModel({ Providers: providers })
  const teamPageModel = new TeamPageModel({ Providers: providers })
  const gdprModel = new GDPRModel({ Providers: providers })

  const ctx = {
    AnalyticsModel: analyticsModel,
    BlogModel: blogModel,
    FaqModel: faqModel,
    GlobalModel: globalModel,
    ModalModel: modalsModel,
    ResponsiveModel: responsiveModel,
    SubscriptionModel: subscriptionModel,
    PaymentTipsModel: paymentTipsModel,
    InappPurchasesModel: inappPurchasesModel,
    ContactUsModel: contactUsModel,
    HuaweiTipsModel: huaweiTipsModel,
    VacanciesModel: vacanciesModel,
    AndroidPaymentsModel: androidPaymentsModel,
    LegalModel: legalModel,
    TeamPageModel: teamPageModel,
    GDPRModel: gdprModel,
  }

  // @ts-ignore
  analyticsModel.setModels(ctx)
  // @ts-ignore
  blogModel.setModels(ctx)
  // @ts-ignore
  faqModel.setModels(ctx)
  // @ts-ignore
  globalModel.setModels(ctx)
  // @ts-ignore
  modalsModel.setModels(ctx)
  // @ts-ignore
  responsiveModel.setModels(ctx)
  // @ts-ignore
  subscriptionModel.setModels(ctx)
  // @ts-ignore
  paymentTipsModel.setModels(ctx)
  // @ts-ignore
  inappPurchasesModel.setModels(ctx)
  // @ts-ignore
  contactUsModel.setModels(ctx)
  // @ts-ignore
  huaweiTipsModel.setModels(ctx)
  // @ts-ignore
  vacanciesModel.setModels(ctx)
  // @ts-ignore
  androidPaymentsModel.setModels(ctx)
  // @ts-ignore
  legalModel.setModels(ctx)
  // @ts-ignore
  teamPageModel.setModels(ctx)
  // @ts-ignore
  gdprModel.setModels(ctx)

  globalModel.setConfig(config.data)

  models.init({
    AnalyticsModel: analyticsModel,
    BlogModel: blogModel,
    FaqModel: faqModel,
    GlobalModel: globalModel,
    ModalModel: modalsModel,
    ResponsiveModel: responsiveModel,
    SubscriptionModel: subscriptionModel,
    PaymentTipsModel: paymentTipsModel,
    InappPurchasesModel: inappPurchasesModel,
    ContactUsModel: contactUsModel,
    HuaweiTipsModel: huaweiTipsModel,
    VacanciesModel: vacanciesModel,
    AndroidPaymentsModel: androidPaymentsModel,
    LegalModel: legalModel,
    TeamPageModel: teamPageModel,
    GDPRModel: gdprModel,
  })

  return models
}
